import { Cache, OperationVariables, useApolloClient } from '@apollo/react-hooks'
import { DocumentNode } from 'graphql'

/** Custom hook to query the cache to determine if query result exists already */
export default function useApolloCacheQuery<T>(
  query: DocumentNode,
  variables?: OperationVariables,
): Cache.DiffResult<T> {
  const { cache } = useApolloClient()
  return cache.diff({
    query: cache.transformDocument(query),
    variables,
    returnPartialData: true,
    optimistic: false,
  })
}
